var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chargingPointId)?_c('v-chip',_vm._g({staticClass:"chip-status",class:_vm.status.toLowerCase()},_vm.$listeners),[_c('v-icon',{attrs:{"left":"","size":"16"}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.label)+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }